import { Environment } from '@typings/environment.type';

export const environment: Environment = {
  production: true,
  stripePK: 'pk_live_51KsXjnKFWMV7xSKbvQPCcSF8ZCLUfGkoNA0MiRN51X7dxsOYcCYOc0oyCJCLiybErAbI81MzUQxqpTf9iXOGGtYQ00dy9LofYb',
  apiDomain: 'https://api.checkplusapp.com',
  sentryDsn: 'https://4dc90dc07a4a4d79b1844293d15df17b@o538667.ingest.sentry.io/4503973121163264',
  sentryAppPath: 'https://app.checkplusapp.com',
};
